<div class="content-info">
    <div class="content-title d-flex justify-content-between align-items-center">
      <h3 class="title">Low Stock Products</h3>
      <div class="title-actions">
        <div class=" form-group">
          <!-- <label class="form-label">Select Location</label> -->
          <select class="form-select form-control" [(ngModel)]="selectedLocationId" (change)="loadLowStock()">
            <option value="">-- Select Location --</option>
            @for (loc of locations; track loc.id) {
              <option [value]="loc.id">{{ loc.name }}</option>
            }
          </select>
        </div>
      </div>

    </div>
  
    <div class="common-table mt-3">
      <div class="table-responsive">
       
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>SKU</th>
            <th>Location</th>
            <th>Available Qty</th>
            <th>Min Qty</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (item of lowStockProducts; track item.id) {
            <tr>
              <td>{{ lowStockProducts.indexOf(item) + 1 }}</td>
              <td>{{ item.product.name }}</td>
              <td>{{ item.product.sku }}</td>
              <td>{{ item.location.name }}</td>
              <td>{{ item.quantity | number : "1.0-3" }}</td>
              <td>{{ item.minQuantity }}</td>
              <td>
                <button class="btn btn-sm btn-primary" (click)="requestRestock(item.product.id, item.minQuantity * 2)">
                  Request Restock
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    </div>
  </div>
  